module.exports = __webpack_public_path__ + "static/media/buzzer-xray1.3310a7b3.aac";